<template>
    <button :type="buttonType"
            :to="url"
            :alt="alt"
            :class="classes">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: "Button",
        props: {
            label: String,
            buttonType: String,
            disabled: Boolean,
            rounded: Boolean,
            round: Boolean,
            flat: Boolean,
            url: String,
            alt: String
        },
        data () {
            return {
                buttonClass: ''
            }
        },
        computed: {
            classes () {
                return (this.round === true ? 'rounded-full p-0' : '') +
                (this.rounded === true ? ' rounded' : '') + 
                (this.disabled === true ? ' cursor-not-allowed' : '')

            }
        }
    }
</script>

<style scoped>
    button {
        transition: all .25s ease;
    }
</style>